<template>
    <v-card>
        <v-card-text>
            <h1 class="host-dashboard-title">Host Dashboard</h1>
            <v-card class="mb-2">
                <v-card-text>
                    <h3>Host Actions</h3>
                    <a @click="createNewEvent">Create Event</a>
                    <br>
                    <a @click="createNewLocation">Create Location</a>
                </v-card-text>
            </v-card>
            <v-card class="mb-2" v-if="unfinishedLocation">
                <v-card-text>
                    <p class="host-dashboard-title ml-3 pt-2">Unfinished Locations</p>
                    <v-divider></v-divider>
                    <v-list two-line class="pa-0">
                        <div v-for="e in getHostProp('partialLocations')" :key="e.pk">
                            <v-list-tile avatar @click="loadLocation(e.id)">
                                <v-list-tile-content>
                                    <div class="ma-0 pa-0"
                                         style="width: 100%; display: flex; flex-direction: row; justify-content: space-between; align-items: center;">
                                        <p class="ma-2 ml-3 host-dashboard-tile-sub-title">#{{ e.id }} - Last Updated:
                                            {{ getUpdateTime(e) }}</p>
                                        <v-btn small @click.stop="deleteLocation(e.id)" class="hidden-xs-only"
                                               style="min-width: 150px;!important">Delete this location
                                        </v-btn>
                                        <v-btn small @click.stop="deleteLocation(e.id)" class="hidden-sm-and-up">
                                            Delete
                                        </v-btn>
                                    </div>
                                </v-list-tile-content>
                            </v-list-tile>
                            <v-divider>
                            </v-divider>
                        </div>
                    </v-list>
                </v-card-text>
            </v-card>
            <v-card class="mb-2" v-if="unfinishedEvent">
                <v-card-text>
                    <p class="host-dashboard-title ml-3 pt-2">Unfinished Events</p>
                    <v-divider></v-divider>
                    <v-list two-line class="pa-0">
                        <div v-for="e in getHostProp('partialEvents')" :key="e.pk">
                            <v-list-tile avatar @click="loadEvent(e.id)">
                                <img v-if="getPartialEventImage(e)" :src="getPartialEventImage(e)"
                                     class="image-thumb pa-2">
                                <v-list-tile-content>
                                    <div class="ma-0 pa-0"
                                         style="width: 100%; display: flex; flex-direction: row; justify-content: space-between; align-items: center;">
                                        <p class="ma-2 ml-3 host-dashboard-tile-sub-title">Last Updated:
                                            {{ getUpdateTime(e) }}</p>
                                        <v-btn small @click.stop="deleteEvent(e.id)" class="hidden-xs-only"
                                               style="min-width: 150px;!important">Delete this event
                                        </v-btn>
                                        <v-btn small @click.stop="deleteEvent(e.id)" class="hidden-sm-and-up">Delete
                                        </v-btn>
                                    </div>
                                </v-list-tile-content>
                            </v-list-tile>
                            <v-divider>
                            </v-divider>
                        </div>
                    </v-list>
                </v-card-text>
            </v-card>
        </v-card-text>
    </v-card>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import moment from 'moment'

export default {
    name: 'host_dashboard',
    mounted() {
        console.log('HostDashboardHome')
        this.fetchAllPartialLocations()
        this.fetchAllPartialEvents()
    },
    methods: {
        ...mapActions([
            'loadPartialEvent',
            'deletePartialEvent',
            'fetchAllPartialEvents',
            'loadPartialLocation',
            'deletePartialLocation',
            'fetchAllPartialLocations',
            'addEventResetState',
            'addLocationResetState',
        ]),
        createNewEvent() {
            this.addEventResetState()
            this.$router.push({name: 'host_add_event_intro'})
        },
        createNewLocation() {
            this.addLocationResetState()
            this.$router.push({name: 'host_add_location_intro'})
        },
        loadEvent(pk) {
            console.log('loadEvent')
            this.loadPartialEvent(pk)
            this.$router.push('/host/add/event/')
        },
        deleteEvent(pk) {
            this.deletePartialEvent(pk)
        },
        deleteLocation(pk) {
            this.deletePartialLocation(pk)
        },
        loadLocation(pk) {
            this.loadPartialLocation(pk)
            this.$router.push('/host/add/location/')
        },
        getUpdateTime(e) {
            if (e.hasOwnProperty('date_updated')) {
                return moment(e.date_updated).format('MM-DD-YYYY')
            } else {
                return ''
            }
        },
        getPartialEventImage(e) {
            let image = e.state.imageObjs.find((img) => {
                img.pk === e.state.primaryImage
            })
            if (image) {
                return image.image
            } else {
                return null
            }
        },
    },
    computed: {
        ...mapGetters([
            'getHostProp',
        ]),
        unfinishedLocation() {
            return this.getHostProp('partialLocations').length > 0
        },
        unfinishedEvent() {
            return this.getHostProp('partialEvents').length > 0
        },
    }
}
</script>

<style>

</style>
